import React from 'react';
import { Box } from '@mui/material';

const ContentWrapper = ({ children }) => {
  return (
    <Box 
      sx={{
        width: '100%',
        maxWidth: '100%',
        // Allow shrinking below wide table min-content so nested overflow-x: auto can scroll
        minWidth: 0,
        bgcolor: { xs: 'transparent', sm: 'background.paper' },
        borderRadius: { xs: 0, sm: 2 },
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        overflowX: 'hidden',
        p: { xs: 1.5, sm: 2 },
        minHeight: 'fit-content'
      }}
    >
      {children}
    </Box>
  );
};

export default ContentWrapper; 
